<template>
  <v-container fluid>
    <v-layout row justify-center align-center>
      <v-flex xs8>
        <v-card>
          <card-toolbar title="İYS İzin Sorgula"></card-toolbar>
          <v-card-text>
            <v-form ref="form">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    required
                    v-model="searchData"
                    :rules="searchDataRule"
                    hide-details="auto"
                    label="Numara"
                    placeholder="Telefon numarasını giriniz"
                    prefix="+90"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    required
                    v-model="selectedType"
                    :rules="selectedTypeRule"
                    hide-details="auto"
                    :items="types"
                    item-text="name"
                    item-value="value"
                    label="İzin Tipini Seçiniz"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    required
                    v-model="selectedBrandCode"
                    :rules="brandCodeRules"
                    hide-details="auto"
                    :items="brandCodes"
                    item-text="name"
                    item-value="value"
                    label="Marka Kodunu Seçiniz"
                  ></v-select>
                </v-col>
                <v-col cols="12" align-self="center">
                  <v-btn
                    color="success"
                    class="mr-4"
                    @click="validate"
                    width="100%"
                  >
                    Sorgula
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-dialog
                    v-model="dialog"
                    transition="dialog-top-transition"
                    max-width="600"
                  >
                    <template v-slot:default="dialog">
                      <v-card>
                        <v-toolbar color="primary" dark class="pl-2">{{
                          queryTitle
                        }}</v-toolbar>
                        <v-card-text>
                          <div class="pt-4">
                            {{ queryDescription }}
                          </div>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                          <v-btn text @click="closeHandler">Kapat</v-btn>
                        </v-card-actions>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import CardToolbar from "@/views/Components/CardToolbar.vue";

export default {
  components: {
    CardToolbar,
  },
  data: () => ({
    searchData: "",
    searchDataRule: [
      (v) => !!v || "Bu alan boş bırakılamaz.",
      (v) =>
        /.+@.+\..+/.test(v) ||
        /^\d{10}$/.test(v) ||
        "Lütfen geçerli numara giriniz.",
    ],

    types: [
      { name: "Mesaj", value: "0" },
      { name: "Arama", value: "1" },
    ],
    selectedType: null,
    selectedTypeRule: [(v) => !!v || "Bu alan boş bırakılamaz."],

    brandCodes: [],
    brandCodeRules: [(v) => !!v || "Bu alan boş bırakılamaz."],
    selectedBrandCode: null,

    rejectionList: [],

    queryTitle: "",
    queryDescription: "",
    descriptions: {
      phone: {
        allowedTitle: "Bu numara İYS tarafından izinli",
        rejectedTitle: "Bu numara İYS tarafından izinli değildir",

        allowedDescription: "Bu numara ticari amaçlı kullanılabilir.",
        rejectedDescription: "Bu numara ticari amaçlı kullanılamaz",
      },
    },

    dialog: false,
  }),

  methods: {
    ...mapActions({ send: "sendBackend" }),
    getData() {
      this.send({
        route: "iys/check-ignored-number",
        data: {
          number: this.searchData,
          type: parseInt(this.selectedType, 10),
          brandCode: this.selectedBrandCode,
        },
      }).then((response) => {
        if (response.data.code === 200) {
          this.rejectionList = response.data.data.data.rejectionList;
          this.dialog = true;

          this.dialogMessage();
        }
      });
    },
    getBrandCodes() {
      this.send({ route: "iys/detail" }).then((response) => {
        this.brandCodes = [
          ...response.data.data.data.map((brand) => ({
            name: `${brand.brandCode} - ${brand.name}`,
            value: brand.brandCode,
          })),
        ];
      });
    },
    dialogMessage() {
      this.queryTitle =
        this.rejectionList.length === 0
          ? this.descriptions.phone.allowedTitle
          : this.descriptions.phone.rejectedTitle;
      this.queryDescription =
        this.rejectionList.length === 0
          ? this.descriptions.phone.allowedDescription
          : this.descriptions.phone.rejectedDescription;

      this.queryDescription = this.queryDescription.replace(
        "amaçlı",
        `amaçlı ${this.types[this.selectedType].name} için`
      );
    },
    closeHandler() {
      this.dialog = false;
      this.$refs.form.reset();
    },
    isValidate() {
      return (
        (/.+@.+\..+/.test(this.searchData) ||
          /^\d{10}$/.test(this.searchData)) &&
        this.selectedType !== null
      );
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.getData();
      }
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$refs.form.reset();
      }
    },
  },
  created() {
    this.getBrandCodes();
  },
};
</script>
